import { render, staticRenderFns } from "./GroupOneRaceTips.vue?vue&type=template&id=54dd9823"
import script from "./GroupOneRaceTips.vue?vue&type=script&lang=js"
export * from "./GroupOneRaceTips.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports